import { Box, styled } from "@mui/material";

export const StyledNoPlayerRoot = styled(Box)({
	display: "flex",
	width: "100%",
	justifyContent: "center",
	alignItems: "center",
	minHeight: 100,
	marginTop: 8,
});
